import {
  ApiBlueprint,
  createApiFactory,
  createFrontendModule,
  createRouteRef,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  AppRootWrapperBlueprint,
  SignInPageBlueprint,
} from '@backstage/plugin-app-react';
import PeopleIcon from '@material-ui/icons/People';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import {
  AccountsClient,
  accountsApiRef,
} from '../../components/accounts/accountsApi';
import { PasswordChangeGate } from '../../components/auth/PasswordChangeGate';

const accountsApi = ApiBlueprint.make({
  name: 'accounts',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: accountsApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new AccountsClient(discoveryApi, fetchApi),
      }),
    ),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { ChiSignInPage } = await import(
        '../../components/auth/ChiSignInPage'
      );
      return ChiSignInPage;
    },
  },
});

const passwordGate = AppRootWrapperBlueprint.make({
  name: 'password-gate',
  params: {
    component: ({ children }) => (
      <PasswordChangeGate>{children}</PasswordChangeGate>
    ),
  },
});

const changePasswordRouteRef = createRouteRef();
const usersRouteRef = createRouteRef();

const changePasswordPage = PageBlueprint.make({
  name: 'change-password',
  params: {
    path: '/change-password',
    title: 'Change password',
    icon: <LockOpenIcon fontSize="inherit" />,
    routeRef: changePasswordRouteRef,
    noHeader: true,
    loader: async () => {
      const { ChangePasswordPage } = await import(
        '../../components/accounts/ChangePasswordPage'
      );
      return <ChangePasswordPage />;
    },
  },
});

const usersPage = PageBlueprint.make({
  name: 'users',
  params: {
    path: '/users',
    title: 'Users',
    icon: <PeopleIcon fontSize="inherit" />,
    routeRef: usersRouteRef,
    noHeader: true,
    loader: async () => {
      const { UsersPage } = await import(
        '../../components/accounts/UsersPage'
      );
      return <UsersPage />;
    },
  },
});

export const accountsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    accountsApi,
    signInPage,
    passwordGate,
    changePasswordPage,
    usersPage,
  ],
});
